import { render, staticRenderFns } from "./genre-grid-block.vue?vue&type=template&id=76af7ce5&scoped=true"
import script from "./genre-grid-block.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-grid-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-grid-block.vue?vue&type=style&index=0&id=76af7ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76af7ce5",
  null
  
)

export default component.exports